var _utils = {
    getScrollY: function () {
        var e = void 0 !== window.pageXOffset,
            t = "CSS1Compat" === (document.compatMode || "");
        return e ? window.pageYOffset : t ? document.documentElement.scrollTop : document.body.scrollTop;
    },
    hasClass: function (e, t) {
        return e.classList ? e.classList.contains(t) : new RegExp("\\b" + t + "\\b").test(e.className);
    },
    addClass: function (e, t) {
        e.classList ? e.classList.add(t) : this.hasClass(e, t) || (e.className += " " + t);
    },
    removeClass: function (e, t) {
        e.classList ? e.classList.remove(t) : (e.className = e.className.replace(new RegExp("\\b" + t + "\\b", "g"), ""));
    },
    each: function (e, t) {
        "string" == typeof e && (e = document.querySelectorAll(e));
        var n = e.length;
        if (!(n < 1)) for (var i = 0; i < n; i++) t(e[i], i);
    },
    debounce: function (e, t, n) {
        var i;
        return function () {
            var s = this,
                a = arguments,
                o = n && !i;
            clearTimeout(i),
                (i = setTimeout(function () {
                    (i = null), n || e.apply(s, a);
                }, t)),
                o && e.apply(s, a);
        };
    },
    disableScroll: function () {
        document.body.style.overflow = "hidden";
    },
    enableScroll: function () {
        document.body.style.overflow = null;
    },
};
void 0 === window._belnu && (window._belnu = { enableTransitions: !0, enablePreloader: !0, refs: {}, blog: { url: "https://topnote.belnu.com", apiBase: "https://topnote.belnu.com/wp-json" } }),
    gsap.registerPlugin(ScrollTrigger),
    document.addEventListener("DOMContentLoaded", function () {
        var e;
        (e = function () {
            _utils.getScrollY() >= 10 ? _utils.addClass(document.body, "is-scrolled") : _utils.removeClass(document.body, "is-scrolled");
        }),
            window.addEventListener("scroll", e),
            e(),
            _utils.each(document.querySelectorAll(".keep-words"), function (e) {
                e.innerHTML = typogr(e.innerHTML).widont();
            });
    }),
    (window._belnu.issueToast = function (e) {
        var t = document.createElement("DIV");
        (t.className = "belnu-toast"),
            (t.innerHTML = e),
            document.body.appendChild(t),
            setTimeout(function () {
                gsap.to(t, {
                    opacity: 0,
                    duration: 0.2,
                    onComplete: function () {
                        t.remove();
                    },
                });
            }, 700);
    }),
    (function () {
        function e(e) {
            (this.el = e.el), (this.triggers = e.triggers), (this.state = { open: !1 }), this.init();
        }
        (e.prototype.init = function () {
            this.setupHandlers();
        }),
            (e.prototype.setupHandlers = function () {
                var e = this;
                _utils.each(this.triggers, function (t) {
                    t.addEventListener("click", function (t) {
                        t.preventDefault(), e.open();
                    });
                }),
                    this.el.querySelector(".belnu-overlay__close").addEventListener("click", function (t) {
                        t.preventDefault(), e.close();
                    });
            }),
            (e.prototype.open = function () {
                this.state.open || (_utils.addClass(document.body, "has-overlay"), gsap.set(this.el, { opacity: 0 }), _utils.addClass(this.el, "m--is-open"), gsap.to(this.el, { opacity: 1, duration: 0.3 }), (this.state.open = !0));
            }),
            (e.prototype.close = function () {
                if (this.state.open) {
                    (this.state.open = !1),
                        _utils.removeClass(document.body, "has-overlay"),
                        gsap.to(this.el, {
                            opacity: 0,
                            duration: 0.3,
                            onComplete: function () {
                                _utils.removeClass(this.el, "m--is-open");
                            }.bind(this),
                        });
                }
            }),
            document.addEventListener("DOMContentLoaded", function () {
                var t;
                (t = document.getElementById("belnu-overlay-about")) && new e({ triggers: document.querySelectorAll('a[href="#about"]'), el: t });
            });
    })(),
    (function () {
        let e = null,
            t = null,
            n = null;
        var i = { open: !1 };
        function s() {
            i.open && setTimeout(r, 1e3);
        }
        function a() {
            [t, n].forEach((e) => {
                e.setAttribute("aria-expanded", i.open);
            });
            (i.open ? n : t).focus({ preventScroll: !0 });
        }
        function o(t = null) {
            null !== t && t.preventDefault(), i.open || ((i.open = !0), _utils.addClass(e, "m--open"), gsap.killTweensOf(e), gsap.fromTo(e, { opacity: 0 }, { opacity: 1, duration: 0.2 }), _utils.disableScroll(), a());
        }
        function r(t = null) {
            null !== t && t.preventDefault(),
                i.open &&
                    ((i.open = !1),
                    gsap.killTweensOf(e),
                    gsap.fromTo(
                        e,
                        { opacity: 1 },
                        {
                            opacity: 0,
                            duration: 0.2,
                            onComplete: () => {
                                _utils.removeClass(e, "m--open"), _utils.enableScroll();
                            },
                        }
                    ),
                    a());
        }
        document.addEventListener("DOMContentLoaded", function () {
            (e = document.getElementById("belnu-nav-overlay")),
                (t = document.querySelector("#belnu-navbar .navbar__trigger")),
                (n = document.querySelector("#belnu-nav-overlay .navbar__trigger")),
                null !== t && t.addEventListener("click", o),
                null !== n && n.addEventListener("click", r),
                window.addEventListener("belnuOpenCart", s);
        });
    })(),
    (function () {
        function e(e) {
            e.preventDefault();
            var t = this.href;
            "function" == typeof CustomEvent && window.dispatchEvent(new CustomEvent("belnuNavigate")),
                gsap.to(document.body, {
                    opacity: 0,
                    duration: 0.2,
                    ease: Circ.easeOut,
                    onComplete: function () {
                        window.location = t;
                    },
                });
        }
        function t() {
            _utils.each(document.querySelectorAll("a"), function (t) {
                var n = t.getAttribute("href"),
                    i = t.getAttribute("target"),
                    s = null != i && "_self" != i,
                    a = /^#(.+)?$/.test(n),
                    o = _utils.hasClass(t, "no-transitions"),
                    r = _utils.hasClass(t, "jdgm-paginate__page");
                
                // Skip external links (target="_blank") and let them open normally
                if (i === "_blank") {
                    return;
                }
                
                s || a || o || r || t.addEventListener("click", e.bind({ href: n }));
            });
        }
        function n(e) {
            e.persisted && gsap.fromTo(document.body, { opacity: 0 }, { opacity: 1, duration: 0.2, ease: Circ.easeOut });
        }
    document.addEventListener("DOMContentLoaded", function () {
        var e;
        
        // Handle external links before page transitions
        (function () {
            // External links handler - automatically opens external links in new tabs
            function isExternalLink(url) {
                if (!url) return false;
                
                // Handle relative URLs and fragments
                if (url.startsWith('#') || url.startsWith('/') || url.startsWith('?')) {
                    return false;
                }
                
                try {
                    const linkUrl = new URL(url);
                    const currentDomain = window.location.hostname;
                    
                    // Check if it's a different domain
                    return linkUrl.hostname !== currentDomain;
                } catch (e) {
                    // If URL parsing fails, assume it's not external
                    return false;
                }
            }
            
            function handleExternalLinks() {
                const links = document.querySelectorAll('a[href]');
                
                links.forEach(link => {
                    const href = link.getAttribute('href');
                    const target = link.getAttribute('target');
                    
                    // Skip if already has target="_blank" or is a social link (already handled)
                    if (target === '_blank' || link.closest('.social-links')) {
                        return;
                    }
                    
                    // Skip if it's in the main navigation menu (keep page transitions)
                    if (link.closest('.navbar__links') || 
                        link.closest('.nav-overlay__menu') || 
                        link.closest('.navbar__menu')) {
                        return;
                    }
                    
                    // Skip if it's an internal link or fragment
                    if (!isExternalLink(href)) {
                        return;
                    }
                    
                    // Add target="_blank" and rel="noopener noreferrer" for security
                    link.setAttribute('target', '_blank');
                    link.setAttribute('rel', 'noopener noreferrer');
                });
            }
            
            // Run immediately
            handleExternalLinks();
            
            // Re-run when new content is added (for dynamic content)
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        // Check if any new links were added
                        const hasNewLinks = Array.from(mutation.addedNodes).some(node => {
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                return node.tagName === 'A' || node.querySelectorAll('a').length > 0;
                            }
                            return false;
                        });
                        
                        if (hasNewLinks) {
                            handleExternalLinks();
                        }
                    }
                });
            });
            
            // Start observing
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        })();
        
        window._belnu.enableTransitions && (t(), (window.onpageshow = n)),
            (e = document.querySelector(".belnu-page-cover")) &&
                gsap.to(e, {
                    opacity: 0,
                    duration: 0.6,
                    ease: Circ.easeOut,
                    onComplete: function () {
                        e.remove();
                    },
                });
    });
    })(),
    (function () {
        let e = [];
        function t() {
            const t = e[0].querySelector("video");
            if (null == t) return;
            const n = t.play();
            void 0 !== n &&
                n.catch(function (t) {
                    "NotAllowedError" === t.name &&
                        [...e].forEach((e) => {
                            _utils.addClass(e, "m--fallback");
                            var t = e.querySelector(".video-autoplay__fallback");
                            _utils.addClass(t, "lazyload");
                        });
                });
        }
        document.addEventListener("DOMContentLoaded", function () {
            (e = document.querySelectorAll(".video-autoplay")), e.length && t();
        });
    })(),
    (function () {
        const e = document.querySelector(".announcement-bar__close"),
            t = document.querySelector(".announcement-bar");
        e.addEventListener("click", function () {
            t.classList.remove("is-active"), sessionStorage.setItem("abShown", "true");
        }),
            "true" != sessionStorage.getItem("abShown") && t.classList.add("is-active");
        const n = document.querySelector("#supermarquee"),
            i = n.dataset.inner;
        if (n) {
            new SuperMarquee(n, { license: "7244BC8E-D9BC4AA0-A5792B0E-FFE4435C", content: i, speed: "superslow", pauseonhover: !0, spacer: "<div class='super__spacer'></div>" });
        }
        let s = document.querySelector(".navbar__nav-monogram"),
            a = document.querySelector(".navbar__nav-logo"),
            footer = document.querySelector(".belnu-footer");
        
        // Configurable offset in pixels from bottom of page (positive = trigger earlier, negative = trigger later)
        const desktopBottomOffset = 250; // Desktop offset value
        const mobileBottomOffset = 150;  // Mobile offset value
        const mobileBreakpoint = 768;    // Screen width breakpoint for mobile
        
        window.onscroll = function (e) {
            if (footer) {
                const isMobile = window.innerWidth < mobileBreakpoint;
                const bottomOffset = isMobile ? mobileBottomOffset : desktopBottomOffset;
                
                const documentHeight = document.body.offsetHeight;
                const scrollPosition = window.scrollY + window.innerHeight;
                const distanceFromBottom = documentHeight - scrollPosition;
                distanceFromBottom <= bottomOffset ? s && (s.classList.add("active"), a.classList.add("is-inactive")) : s && (s.classList.remove("active"), a.classList.remove("is-inactive"));
            }
        };
    })();
class BelnuTestimonialSlider {
    constructor(e) {
        (this.el = e), (this.swiper = null), (this.thumbsSwiper = null), (this.isUpdating = false), this.init();
    }
    setTitle(e) {
        const t = e.slides[e.activeIndex];
        t.hasAttribute("data-cite") && (this.el.querySelector(".swiper-current-title").innerText = t.getAttribute("data-cite"));
    }
    sliderChange(e) {
        if (this.thumbsSwiper && !this.isUpdating) {
            this.isUpdating = true;
            this.thumbsSwiper.slideToLoop(e.realIndex, 600);
            setTimeout(() => { this.isUpdating = false; }, 100);
        }
    }
    thumbSliderChange(e) {
        if (this.swiper && !this.isUpdating && this.swiper.realIndex !== e.realIndex) {
            this.isUpdating = true;
            this.swiper.slideToLoop(e.realIndex, 600);
            setTimeout(() => { this.isUpdating = false; }, 100);
        }
    }
    init() {
        const e = this.el.querySelector(".testimonial-slider__slider-main"),
            t = this.el.querySelector(".testimonial-slider__slider-thumbs"),
            autoplayEnabled = this.el.dataset.autoplay === 'true',
            autoplayDelay = parseInt(this.el.dataset.autoplayDelay) || 5000;
        
        const swiperConfig = {
            effect: "fade",
            fadeEffect: { crossFade: !0 },
            slidesPerView: 1,
            autoHeight: !0,
            loop: !0,
            loopAdditionalSlides: 2,
            speed: 600,
            centeredSlides: true,
            pagination: { el: ".swiper-pagination", type: "fraction" },
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
            on: { 
                init: this.setTitle.bind(this), 
                slideChange: this.setTitle.bind(this), 
                realIndexChange: this.sliderChange.bind(this) 
            },
        };

        if (autoplayEnabled) {
            swiperConfig.autoplay = {
                delay: autoplayDelay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            };
        }

        e && (this.swiper = new Swiper(e, swiperConfig));
        t && (this.thumbsSwiper = new Swiper(t, { 
            spaceBetween: 32, 
            slidesPerView: "auto", 
            centeredSlides: !0, 
            loop: !0,
            loopAdditionalSlides: 2,
            speed: 600,
            slideToClickedSlide: !0, 
            allowTouchMove: !1, 
            on: { 
                realIndexChange: this.thumbSliderChange.bind(this) 
            } 
        }));
    }
}
window.addEventListener("DOMContentLoaded", () => {
    _utils.each(".testimonial-slider", (e) => {
        new BelnuTestimonialSlider(e);
    });
});
class BelnuProductGallery {
    constructor(e) {
        (this.el = e), (this.swiper1 = null), (this.swiper2 = null), (this.state = { slidesCount: 0, hasThumbSlider: !1 }), this.init();
    }
    handleThumbClick(e) {
        const t = parseInt(e.getAttribute("data-real-index"));
        this.swiper1.slideTo(t);
    }
    getNext(e) {
        let t = e + 1;
        return t >= this.state.slidesCount ? 0 : t;
    }
    handleSlideChange(e) {
        this.swiper2 && this.swiper2.slideTo(this.getNext(e.realIndex));
    }
    init() {
        this.initSliders(), window.addEventListener("belnuVariantChange", this.handleVariantChange.bind(this));
    }
    initSliders() {
        const e = this.el.querySelector(".product-gallery__slider1"),
            t = this.el.querySelector(".product-gallery__slider2");
        if (!e) return;
        this.state.slidesCount = e.querySelectorAll(".swiper-slide").length;
        const n = this.el.dataset.featuredPosition ? parseInt(this.el.dataset.featuredPosition) - 1 : 0;
        (this.swiper1 = new Swiper(e, {
            slidesPerView: 1,
            loop: !1,
            initialSlide: n,
            effect: "fade",
            fadeEffect: { crossFade: !0 },
            slidesPerView: 1,
            speed: 2e3,
            autoplay: { delay: 4e3 },
            watchSlidesProgress: !0,
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        })),
            t &&
                ((this.swiper2 = new Swiper(t, { loop: !1, slidesPerView: 6, spaceBetween: 10, breakpoints: { 900: { spaceBetween: 20 } }, thumbs: { swiper: e } })),
                t.querySelectorAll(".swiper-slide").forEach((e) => {
                    e.addEventListener("click", this.handleThumbClick.bind(this, e));
                }));
    }
    handleVariantChange(e) {
        const t = e.detail.variant;
        if (t.featured_media) {
            const e = parseInt(t.featured_media.position) - 1;
            this.swiper1.slideTo(e);
        }
    }
}
window.addEventListener("DOMContentLoaded", () => {
    _utils.each(".product-gallery", (e) => {
        new BelnuProductGallery(e);
    });
});
class BelnuInstagramFeature {
    constructor(e) {
        (this.el = e), this.init();
    }
    init() {
        const e = this.el.querySelector(".instagram-feature__track"),
            t = -100 - 0.667 * window.innerHeight;
        gsap.timeline({ scrollTrigger: { trigger: e, start: "top bottom", end: "bottom top", scrub: !0 } }).fromTo(e, { x: -100 }, { x: t, duration: 10 });
    }
}
window.addEventListener("DOMContentLoaded", () => {
    _utils.each(".instagram-feature", (e) => {
        new BelnuInstagramFeature(e);
    });
});
class BelnuQuantity {
    constructor(e) {
        (this.el = e), (this.state = { value: null, min: 0, max: null }), this.init();
    }
    correctBounds(e) {
        return e < this.state.min ? this.state.min : null !== this.state.max && e > this.state.max ? this.state.max : e;
    }
    getValue() {
        return parseInt(this.inputEl.value);
    }
    setValue(e) {
        (this.inputEl.value = this.correctBounds(e)), this.inputEl.dispatchEvent(new Event("change"));
    }
    increase(e) {
        e.preventDefault(), this.setValue(this.getValue() + 1);
    }
    decrease(e) {
        e.preventDefault(), this.setValue(this.getValue() - 1);
    }
    init() {
        (this.btnIncrease = this.el.querySelector('button[name="plus"]')),
            (this.btnDecrease = this.el.querySelector('button[name="minus"]')),
            (this.inputEl = this.el.querySelector("input")),
            this.inputEl.hasAttribute("max") && (this.state.max = parseInt(this.inputEl.getAttribute("max"))),
            this.btnIncrease.addEventListener("click", this.increase.bind(this)),
            this.btnDecrease.addEventListener("click", this.decrease.bind(this));
    }
}
window.addEventListener("DOMContentLoaded", () => {
    function e() {
        _utils.each(".qty-group", (e) => {
            new BelnuQuantity(e);
        });
    }
    e(), document.addEventListener("belnuCartUpdated", e);
}),
    (function () {
        let e = [];
        function t(e) {
            _utils.each(".cart-count", (t) => {
                t.innerText = e;
            });
            let t = document.querySelector(".js-cart-item-s");
            _utils.each(".navbar__cart", (n) => {
                0 == e
                    ? (_utils.removeClass(n, "m--cart-empty"), t.classList.add("active"))
                    : 1 == e
                    ? (_utils.removeClass(n, "m--cart-empty"), t.classList.remove("active"))
                    : e > 1
                    ? (t.classList.add("active"), _utils.removeClass(n, "m--cart-empty"))
                    : t.classList.remove("active");
            });
        }
        function n(n, s) {
            e.forEach((e) => {
                e.enableLoading();
            }),
                (async function (e, t) {
                    const n = { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" } },
                        i = JSON.stringify({ line: e, quantity: t, sections: ["cart-drawer", "main-cart"], sections_url: window.location.pathname });
                    return fetch(`${routes.cart_change_url}`, { ...n, body: i })
                        .then((e) => e.text())
                        .then((e) => JSON.parse(e));
                })(n, s)
                    .then((e) => {
                        t(e.item_count), i(e.sections);
                    })
                    .catch((e) => {
                        console.error("Error:", e);
                    })
                    .finally(() => {
                        e.forEach((e) => {
                            e.disableLoading();
                        });
                    });
        }
        function i(t) {
            e.forEach((e) => {
                e.render(t[e.section]);
            }),
                document.dispatchEvent(new CustomEvent("belnuCartUpdated"));
        }
        function s(e) {
            const n = e.detail.response;
            i(n.sections);
            const s = new DOMParser().parseFromString(n.sections["cart-drawer"], "text/html");
            t(parseInt(s.querySelector(".cart-count").innerText));
        }
        class a {
            constructor(e, t = {}) {
                (this.el = e), (this.section = t.section), this.init();
            }
            init() {
                this.setupEvents();
            }
            reinit() {
                this.init();
            }
            setupEvents() {
                this.el.querySelectorAll(".cart-contents__items .qty-group input").forEach((e) => {
                    e.addEventListener(
                        "change",
                        _utils.debounce((e) => {
                            this.onChange(e);
                        }, 500)
                    );
                });
                
                // Handle remove buttons for manual upsell products
                this.el.querySelectorAll(".cart-item__remove-btn").forEach((btn) => {
                    btn.addEventListener("click", (e) => {
                        this.onRemove(e);
                    });
                });
            }
            onChange(e) {
                n(e.target.getAttribute("data-index"), e.target.value);
            }
            onRemove(e) {
                const index = e.target.getAttribute("data-index");
                n(index, 0); // Set quantity to 0 to remove the item
            }
            enableLoading() {
                _utils.addClass(this.el, "m--loading");
            }
            disableLoading() {
                _utils.removeClass(this.el, "m--loading");
            }
            render(e) {
                const t = new DOMParser().parseFromString(e, "text/html").querySelector(".cart-contents");
                [...this.el.children].forEach((e) => {
                    e.remove();
                }),
                    (this.el.innerHTML = t.innerHTML),
                    this.reinit();
            }
        }
        document.addEventListener("DOMContentLoaded", () => {
            const t = document.querySelector(".shopify-section.cart-drawer .cart-contents");
            t && e.push(new a(t, { section: "cart-drawer" }));
            const n = document.querySelector(".shopify-section.main-cart .cart-contents");
            n && e.push(new a(n, { section: "main-cart" })), window.addEventListener("belnuQuickAdd", s);
        });
    })();
class BelnuCartDrawer {
    constructor(e) {
        (this.el = e), (this.state = { open: !1 }), this.init();
    }
    init() {
        (this.overlayEl = this.el.querySelector(".cart-drawer__overlay")), (this.mainEl = this.el.querySelector(".cart-drawer__main")), (this.closeBtn = this.el.querySelector("#cart-drawer-close")), this.setupEvents();
    }
    setupEvents() {
        document.querySelectorAll("[data-cart-trigger]").forEach((e) => {
            e.addEventListener("click", this.open.bind(this));
        }),
            this.closeBtn.addEventListener("click", this.close.bind(this)),
            this.overlayEl.addEventListener("click", this.close.bind(this)),
            window.addEventListener("belnuQuickAdd", this.open.bind(this));
    }
    open(e = null) {
        e && e.preventDefault(),
            "function" == typeof CustomEvent && window.dispatchEvent(new CustomEvent("belnuOpenCart")),
            (this.el.style.display = "block"),
            gsap.fromTo(this.overlayEl, { opacity: 0 }, { opacity: 1, duration: 0.3, ease: "circ.out" }),
            gsap.fromTo(this.mainEl, { x: "100%" }, { x: "0%", duration: 0.3, ease: "circ.out" }),
            (this.state.open = !0),
            this.updateAria();
    }
    close(e = null) {
        e && e.preventDefault();
        gsap.to(this.overlayEl, { opacity: 0, duration: 0.3, ease: "circ.out" }),
            gsap.to(this.mainEl, {
                x: "100%",
                duration: 0.3,
                ease: "circ.out",
                onComplete: () => {
                    (this.el.style.display = "none"), (this.state.open = !1), this.updateAria();
                },
            });
    }
    updateAria() {
        this.el.setAttribute("aria-hidden", this.state.open ? "false" : "true");
    }
}
window.addEventListener("DOMContentLoaded", () => {
    const e = document.getElementById("shopify-section-cart-drawer");
    e && (window._belnu.refs.cartDrawer = new BelnuCartDrawer(e));
});
class BelnuAddToCart {
    constructor(e, t) {
        (this.el = e), (this.formEl = null), (this.buttonEl = null), (this.options = t), this.init();
    }
    init() {
        "form" === this.options.type
            ? ((this.formEl = this.el.querySelector("form")), (this.buttonEl = this.el.querySelector('button[type="submit"]')), this.formEl.addEventListener("submit", this.onSubmit.bind(this)))
            : "quick-add" === this.options.type && ((this.buttonEl = this.el), this.el.addEventListener("click", this.onSubmit.bind(this)));
    }
    enableLoading() {
        _utils.addClass(this.buttonEl, "m--loading");
    }
    disableLoading() {
        _utils.removeClass(this.buttonEl, "m--loading");
    }
    onSubmit(e) {
        e.preventDefault(), this.enableLoading();
        let t = { id: 0, quantity: 1 };
        "form" === this.options.type ? (t.id = parseInt(this.el.querySelector('input[name="id"]').value), this.el.querySelector('input[name="properties[Pre-order]"]') && (t.properties = { "Pre-order": this.el.querySelector('input[name="properties[Pre-order]"]').value })) : "quick-add" === this.options.type && (t.id = parseInt(this.el.getAttribute("data-variant-id")));
        const n = { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [t], sections: ["cart-drawer", "main-cart"], sections_url: window.location.pathname }) };
        fetch(window.Shopify.routes.root + "cart/add.js", { ...n })
            .then((e) => e.json())
            .then((e) => {
                if ("function" == typeof CustomEvent) {
                    const t = new CustomEvent("belnuQuickAdd", { detail: { response: e } });
                    window.dispatchEvent(t);
                }
            })
            .catch((e) => {
                console.error("Error:", e);
            })
            .finally(() => {
                this.disableLoading();
            });
    }
}
window.addEventListener("DOMContentLoaded", () => {
    _utils.each(".product-form", (e) => {
        new BelnuAddToCart(e, { type: "form" });
    }),
        _utils.each(".quick-add", (e) => {
            new BelnuAddToCart(e, { type: "quick-add" });
        });
});

// Mini Auto-Addition System
class BelnuMiniAutoAdd {
    constructor() {
        this.init();
    }

    init() {
        // Listen for successful cart additions
        window.addEventListener('belnuQuickAdd', this.handleCartAdd.bind(this));
    }

    async handleCartAdd(event) {
        const response = event.detail.response;
        
        // Check if any added items are 50ML products that need mini versions
        if (response.items) {
            // Get cart state once at the beginning
            const cartResponse = await fetch('/cart.js');
            const currentCart = await cartResponse.json();
            
            // Process all items in parallel for better performance
            const promises = response.items.map(addedItem => 
                this.checkAndAddMini(addedItem, currentCart)
            );
            await Promise.all(promises);
        }
    }

    async checkAndAddMini(addedItem, currentCart) {
        try {
            // Get product details to check if it's a 50ML product
            const productResponse = await fetch(`/products/${addedItem.handle}.js`);
            const product = await productResponse.json();
            
            // Check if product is in 50ml collection (primary method)
            let is50ML = false;
            
            // Method 1: Check collections (most reliable)
            if (product.collections) {
                is50ML = product.collections.some(collection => collection.handle === '50ml');
            }
            
            // Method 2: Fallback - check tags and product type
            if (!is50ML) {
                is50ML = (product.tags && product.tags.some(tag => tag.toLowerCase().includes('50ml'))) || 
                        (product.product_type && product.product_type.toLowerCase().includes('50ml'));
            }
            
            if (!is50ML) return;

            // Look for corresponding mini product
            const miniProductHandle = await this.findMiniProduct(product.title);
            if (!miniProductHandle) return;

            // Check if mini is already in cart (use passed cart state instead of fetching)
            const miniAlreadyInCart = currentCart.items.some(item => 
                item.handle === miniProductHandle && 
                item.properties && 
                item.properties._auto_mini === 'true'
            );

            const bottles = currentCart.items.filter(i => i.product_id === addedItem.product_id).reduce((n, i) => n + i.quantity, 0); const minis = currentCart.items.filter(i => i.handle === miniProductHandle && i.properties && i.properties._auto_mini === 'true').reduce((n, i) => n + i.quantity, 0); if (miniAlreadyInCart && minis >= bottles) return;

            // Add mini product to cart
            await this.addMiniToCart(miniProductHandle, addedItem.product_title);

        } catch (error) {
            console.error('Error in mini auto-addition:', error);
        }
    }

    async findMiniProduct(productTitle) {
        try {
            // Create mini product title by appending " Mini"
            const miniTitle = `${productTitle} Mini`;
            
            // Search for the mini product
            const searchResponse = await fetch(`/search/suggest.json?q=${encodeURIComponent(miniTitle)}&resources[type]=product&resources[limit]=5`);
            const searchData = await searchResponse.json();
            
            if (searchData.resources?.results?.products) {
                const miniProduct = searchData.resources.results.products.find(product => 
                    product.title.toLowerCase() === miniTitle.toLowerCase()
                );
                
                const preferred = searchData.resources.results.products.find(p => p.title.toLowerCase() === miniTitle.toLowerCase() && /1-5ml/i.test(p.handle)); return preferred ? preferred.handle : (miniProduct ? miniProduct.handle : null);
            }
            
            return null;
        } catch (error) {
            console.error('Error finding mini product:', error);
            return null;
        }
    }

    async addMiniToCart(miniHandle, parentProductTitle) {
        try {
            // Get mini product details
            const productResponse = await fetch(`/products/${miniHandle}.js`);
            const miniProduct = await productResponse.json();
            
            if (!miniProduct.available) return;

            const variantId = miniProduct.variants[0].id;

            // Add mini to cart with special properties
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1,
                        properties: {
                            '_auto_mini': 'true',
                            '_parent_product': parentProductTitle,
                            '_note': `Complimentary mini included with ${parentProductTitle}`
                        }
                    }],
                    sections: ['cart-drawer', 'main-cart'],
                    sections_url: window.location.pathname
                })
            });

            if (response.ok) {
                const data = await response.json();
                // Trigger cart update
                const updateEvent = new CustomEvent('belnuQuickAdd', {
                    detail: { response: data }
                });
                window.dispatchEvent(updateEvent);
            }

        } catch (error) {
            console.error('Error adding mini to cart:', error);
        }
    }
}

// Initialize Mini Auto-Addition System
window.addEventListener('DOMContentLoaded', () => {
    new BelnuMiniAutoAdd();
});

// Auto-remove mini products when parent 50ML is removed
async function autoRemoveMiniProducts() {
    try {
        // Get current cart state
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        // Find all auto-mini items
        const autoMiniItems = cart.items.filter(item => 
            item.properties && item.properties._auto_mini === 'true'
        );
        
        if (autoMiniItems.length === 0) return;
        
        // Check if their parent products are still in cart
        const parentProductsInCart = cart.items
            .filter(item => !item.properties || item.properties._auto_mini !== 'true')
            .map(item => item.product_title);
        
        // Remove orphaned mini products
        for (const miniItem of autoMiniItems) {
            const parentProduct = miniItem.properties._parent_product;
            
            if (!parentProductsInCart.includes(parentProduct)) {
                // Parent product was removed, remove this mini
                const freshCartResponse = await fetch('/cart.js');
                const freshCart = await freshCartResponse.json();
                const lineIndex = freshCart.items.findIndex(item => item.key === miniItem.key);
                
                if (lineIndex !== -1) {
                    const response = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            line: lineIndex + 1,
                            quantity: 0,
                            sections: ['cart-drawer', 'main-cart'],
                            sections_url: window.location.pathname
                        })
                    });
                    
                    if (response.ok) {
                        const data = await response.json();
                        const event = new CustomEvent('belnuQuickAdd', {
                            detail: { response: data }
                        });
                        window.dispatchEvent(event);
                    }
                }
                
                // Small delay between removals
                await new Promise(resolve => setTimeout(resolve, 25));
            }
        }
        
    } catch (error) {
        console.error('Error during auto-removal of mini products:', error);
    }
}

// Listen for cart updates to trigger mini cleanup
document.addEventListener('belnuCartUpdated', () => {
    // Use requestAnimationFrame for better performance than setTimeout
    requestAnimationFrame(() => {
        autoRemoveMiniProducts();
    });
});
class BelnuVariants {
    constructor(e) {
        (this.el = e), this.init();
    }
    init() {
        this.addListeners();
    }
    addListeners() {
        const e = this.el.querySelectorAll('.variant-selects, input[type="radio"]');
        _utils.each(e, (e) => {
            e.addEventListener("change", this.handleChange.bind(this));
        });
    }
    handleChange() {
        this.updateOptions(), this.updateMasterId(), this.currentVariant ? (this.updateVariantInput(), this.updateURL(), this.renderProductInfo()) : this.setUnavailable();
    }
    updateOptions() {
        this.options = Array.from(this.el.querySelectorAll(".variant-selects, fieldset"), (e) =>
            "SELECT" === e.tagName ? e.value : "FIELDSET" === e.tagName ? Array.from(e.querySelectorAll("input")).find((e) => e.checked)?.value : void 0
        );
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((e) => !e.options.map((e, t) => this.options[t] === e).includes(!1));
    }
    getVariantData() {
        return (this.variantData = this.variantData || JSON.parse(document.getElementById("variants-data").textContent)), this.variantData;
    }
    updateVariantInput() {
        const e = document.querySelector('.product-form input[name="id"]');
        (e.value = this.currentVariant.id), e.dispatchEvent(new Event("change", { bubbles: !0 }));
    }
    updateURL() {
        this.currentVariant && "false" !== this.el.dataset.updateUrl && window.history.replaceState({}, "", `${this.el.dataset.url}?variant=${this.currentVariant.id}`);
    }
    setUnavailable() {
        this.updateAddButton(!1, "Add to cart");
    }
    updateAddButton(e = !1, t = "Add to cart") {
        const n = document.querySelector(".product-sidebar .product-form__submit");
        e ? n.removeAttribute("disabled") : n.setAttribute("disabled", !0), (n.querySelector("span").innerText = t);
    }
    renderProductInfo() {
        const e = document.querySelector(".product-sidebar");
        _utils.addClass(e, "m--loading");
        const t = this.currentVariant.id,
            n = this.el.dataset.section;
        fetch(`${this.el.dataset.url}?variant=${t}&section_id=${n}`)
            .then((e) => e.text())
            .then((n) => {
                if (this.currentVariant.id !== t) return;
                const i = new DOMParser().parseFromString(n, "text/html"),
                    s = document.querySelector(".product-sidebar .price"),
                    a = i.querySelector(".product-sidebar .price");
                s.innerHTML = a.innerHTML;
                const o = i.querySelector(".product-sidebar .product-form__submit");
                this.updateAddButton(this.currentVariant.available, o.innerText.trim()), _utils.removeClass(e, "m--loading"), this.emittEvent();
            });
    }
    emittEvent() {
        if ("function" != typeof CustomEvent) return;
        const e = new CustomEvent("belnuVariantChange", { detail: { variant: this.currentVariant } });
        window.dispatchEvent(e);
    }
}
window.addEventListener("DOMContentLoaded", () => {
    const e = document.querySelector(".variant-selects");
    e && new BelnuVariants(e);
}),
    (function () {
        let e = null;
        document.addEventListener("DOMContentLoaded", function () {
            (e = document.getElementById("page-navigation")),
                e &&
                    (function () {
                        const t = document.querySelectorAll(".shopify-section [data-nav-title]"),
                            n = e.querySelector(".page-navigation__links");
                        t.forEach((e) => {
                            var t = document.createElement("LI"),
                                i = document.createElement("A");
                            (i.innerText = e.getAttribute("data-nav-title")), (i.href = `#${e.id}`), t.appendChild(i), n.appendChild(t);
                        });
                    })();
        });
    })(),
    (function () {
        var e = null;
        document.addEventListener("DOMContentLoaded", function () {
            var t, n, i, s;
            (e = document.getElementById("belnu-preloader")),
                _utils.hasClass(document.documentElement, "shopify-design-mode") && (window._belnu.enablePreloader = !1),
                window._belnu.enablePreloader && null != e && _utils.hasClass(document.documentElement, "has-preloader")
                    ? ((t = e.querySelector(".belnu-monogram")),
                      (n = gsap.timeline({
                          onComplete: function () {
                              e.style.display = "none";
                          },
                      })),
                      (i = { duration: 0.8, pause: 0.4, targetBlur: window.innerWidth < 600 ? 80 : 112, easing: Power2.easeOut }),
                      (s = { blur: i.targetBlur }),
                      n.fromTo(t, { opacity: 0 }, { opacity: 1, duration: i.duration, ease: i.easing }),
                      n.to(
                          s,
                          {
                              blur: 0,
                              duration: i.duration,
                              ease: i.easing,
                              onUpdate: function () {
                                  t.style.setProperty("--blur", s.blur + "px");
                              },
                          },
                          "<"
                      ),
                      n.to(t, { opacity: 0, duration: i.duration, ease: i.easing }, `+=${i.pause}`),
                      n.to(
                          s,
                          {
                              blur: i.targetBlur,
                              duration: i.duration,
                              ease: i.easing,
                              onUpdate: function () {
                                  t.style.setProperty("--blur", s.blur + "px");
                              },
                          },
                          "<"
                      ),
                      n.to(e, { opacity: 0, duration: i.duration, ease: i.easing }, "-=" + i.duration / 2))
                    : (function () {
                          window._belnu.enablePreloader || (e.style.display = "none");
                          document.body.classList.add("preloader-done"), "function" == typeof CustomEvent && window.dispatchEvent(new CustomEvent("belnuPreloaderDone"));
                      })();
        });
    })();
class BelnuCollection {
    constructor(e) {
        (this.el = e), (this.gridEl = null), this.init();
    }
    init() {
        this.gridEl = document.getElementById("product-grid-main");
        const e = document.getElementById("sort-by");
        e && e.addEventListener("change", this.sortChange.bind(this));
    }
    sortChange(e) {
        const t = e.target;
        (document.getElementById("sort-current").innerText = t.options[t.selectedIndex].text), this.reload({ sort_by: e.target.value });
    }
    reload(e) {
        let t = window.location.origin + window.location.pathname + "?",
            n = [];
        for (let t in e) n.push(`${t}=${e[t]}`);
        (t += n.join("&")),
            _utils.addClass(this.el, "m--loading"),
            fetch(t)
                .then((e) => e.text())
                .then((e) => {
                    this.updateGrid(e);
                });
    }
    updateGrid(e) {
        const t = new DOMParser().parseFromString(e, "text/html").getElementById("product-grid-main");
        for (; this.gridEl.firstChild; ) this.gridEl.removeChild(this.gridEl.firstChild);
        [...t.children].forEach((e) => {
            this.gridEl.appendChild(e);
        }),
            _utils.removeClass(this.el, "m--loading");
    }
}
window.addEventListener("DOMContentLoaded", () => {
    _utils.each(".product-grid", (e) => {
        new BelnuCollection(e);
    });
});
class BelnuFeaturedBlog {
    constructor(e) {
        (this.el = e), this.init();
    }
    init() {
        this.fetch().then((e) => {
            if (void 0 === e) return;
            const t = this.el.querySelector(".featured-blog__grid");
            t && (t.innerHTML = e.html);
        });
    }
    async fetch() {
        return fetch(`${window._belnu.blog.apiBase}/belnu/v1/rendered-posts`, { method: "GET", headers: { "Content-Type": "application/json", Accept: "application/json" } })
            .then((e) => {
                if (e.ok) return e.text();
                throw new Error("Error fetching blog posts");
            })
            .then((e) => JSON.parse(e))
            .catch((e) => {
                console.error("Error fetching blog posts:", e);
            });
    }
}
window.addEventListener("DOMContentLoaded", () => {
    _utils.each(".featured-blog", (e) => {
        new BelnuFeaturedBlog(e);
    });
});
class BelnuSlideshow {
    constructor(e) {
        (this.el = e), (this.swiper = null), this.init();
    }
    init() {
        this.swiper = new Swiper(this.el, {
            loop: !0,
            effect: "fade",
            fadeEffect: { crossFade: !0 },
            slidesPerView: 1,
            speed: 2e3,
            autoplay: { delay: 4e3 },
            pagination: { el: ".swiper-pagination", type: "fraction" },
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        });
    }
}
window.addEventListener("DOMContentLoaded", () => {
    _utils.each(".slideshow", (e) => {
        new BelnuSlideshow(e);
    });
});

// Upsell Widget Class
class BelnuUpsell {
    constructor(element) {
        this.element = element;
        this.maxSamples = parseInt(element.dataset.maxSamples) || 2;
        this.isUpdating = false;
        this.init();
    }

    init() {
        this.setupEventListeners();
        this.updateUI();
    }

    setupEventListeners() {
        // Remove any existing event listeners first
        this.removeEventListeners();
        
        const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
        
        // Store references to bound handlers for cleanup
        this.boundHandlers = [];
        
        checkboxes.forEach((checkbox) => {
            const boundHandler = this.handleCheckboxChange.bind(this);
            checkbox.addEventListener('change', boundHandler);
            this.boundHandlers.push({ checkbox, handler: boundHandler });
        });
    }

    removeEventListeners() {
        if (this.boundHandlers) {
            this.boundHandlers.forEach(({ checkbox, handler }) => {
                if (checkbox && checkbox.removeEventListener) {
                    checkbox.removeEventListener('change', handler);
                }
            });
        }
        this.boundHandlers = [];
    }

    handleCheckboxChange(event) {
        if (this.isUpdating) return;
        
        const checkbox = event.target;
        const variantId = checkbox.dataset.variantId;
        const cartKey = checkbox.dataset.cartKey;
        
        if (checkbox.checked) {
            this.addUpsellItem(variantId, checkbox);
        } else {
            this.removeUpsellItem(cartKey, checkbox);
        }
    }

    async addUpsellItem(variantId, checkbox) {
        this.setLoading(true);
        
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1,
                        properties: {
                            '_upsell_item': 'true'
                        }
                    }],
                    sections: ['cart-drawer', 'main-cart'],
                    sections_url: window.location.pathname
                })
            });

            if (response.ok) {
                const data = await response.json();
                this.triggerCartUpdate(data);
            } else {
                const errorText = await response.text();
                console.error('Failed to add sample to cart:', response.status, errorText);
                // Revert checkbox if failed
                checkbox.checked = false;
            }
        } catch (error) {
            checkbox.checked = false;
            console.error('Error adding sample:', error);
        } finally {
            this.setLoading(false);
        }
    }

    async removeUpsellItem(cartKey, checkbox) {
        const variantId = checkbox.dataset.variantId;
        
        this.setLoading(true);

        try {
            // Get current cart to find line item
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            
            // Find the line item by variant ID and free sample property
            const lineItemIndex = cart.items.findIndex(item => 
                item.variant_id == variantId && 
                item.properties && 
                item.properties._upsell_item === 'true'
            );
            
            if (lineItemIndex !== -1) {
                // Use 1-based line number for Shopify API
                const lineNumber = lineItemIndex + 1;
                
                const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        line: lineNumber,
                        quantity: 0,
                        sections: ['cart-drawer', 'main-cart'],
                        sections_url: window.location.pathname
                    })
                });

                if (response.ok) {
                    const data = await response.json();
                    this.triggerCartUpdate(data);
                } else {
                    const errorText = await response.text();
                    console.error('Failed to remove upsell item from cart:', response.status, errorText);
                    // Revert checkbox if failed
                    checkbox.checked = true;
                }
            } else {
                console.error('Cart item not found:', { variantId, cartKey, cartItems: cart.items });
                checkbox.checked = true;
            }
        } catch (error) {
            checkbox.checked = true;
            console.error('Error removing sample:', error);
        } finally {
            this.setLoading(false);
        }
    }

    triggerCartUpdate(data) {
        // Use existing cart update system
        const event = new CustomEvent('belnuQuickAdd', {
            detail: { response: data }
        });
        window.dispatchEvent(event);
    }

    updateUI() {
        const selectedCount = this.element.querySelectorAll('input[type="checkbox"]:checked').length;
        const counter = this.element.querySelector('.cart-upsell__count');
        
        if (counter) {
            counter.textContent = `${selectedCount}/${this.maxSamples}`;
        }

        // Update element data attribute
        this.element.dataset.selectedCount = selectedCount;

        // Enable/disable checkboxes and update item states
        const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
        const items = this.element.querySelectorAll('.cart-upsell__item');
        
        checkboxes.forEach((checkbox, index) => {
            const item = items[index];
            const shouldDisable = !checkbox.checked && selectedCount >= this.maxSamples;
            
            checkbox.disabled = shouldDisable;
            
            if (item) {
                item.dataset.disabled = shouldDisable.toString();
            }
        });
    }

    setLoading(isLoading) {
        this.isUpdating = isLoading;
        const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
        
        checkboxes.forEach(checkbox => {
            checkbox.disabled = isLoading;
        });
        
        if (isLoading) {
            _utils.addClass(this.element, 'm--loading');
        } else {
            _utils.removeClass(this.element, 'm--loading');
        }
    }

    // Method to reinitialize after cart updates
    reinit() {
        // Update element reference in case DOM was replaced
        const newElement = document.querySelector('.cart-upsell');
        if (newElement) {
            this.element = newElement;
            // Read the updated max samples from the DOM (now dynamic)
            this.maxSamples = parseInt(newElement.dataset.maxSamples) || 2;
        }
        this.init();
    }
}

// Initialize Upsell Widget
let upsellInstance = null;

// Function to automatically remove orphaned upsell items
async function autoRemoveUpsellItems() {
    try {
        // Small delay to let the cart settle after qualifying product removal
        await new Promise(resolve => setTimeout(resolve, 50));
        
        // Get FRESH cart state after the delay
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        // Find all upsell items by properties, not line numbers
        const upsellKeys = [];
        cart.items.forEach(item => {
            if (item.properties && item.properties._upsell_item === 'true') {
                upsellKeys.push(item.key);
            }
        });
        
        if (upsellKeys.length === 0) {
            return; // No upsell items to remove
        }
        
        // Remove each upsell item using fresh line numbers
        for (const key of upsellKeys) {
            // Get fresh cart state for each removal
            const freshCartResponse = await fetch('/cart.js');
            const freshCart = await freshCartResponse.json();
            const lineIndex = freshCart.items.findIndex(item => item.key === key);
            
            if (lineIndex !== -1) {
                const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        line: lineIndex + 1,
                        quantity: 0,
                        sections: ['cart-drawer', 'main-cart'],
                        sections_url: window.location.pathname
                    })
                });
                
                if (response.ok) {
                    // Success - trigger immediate update for this removal
                    const data = await response.json();
                    const event = new CustomEvent('belnuQuickAdd', {
                        detail: { response: data }
                    });
                    window.dispatchEvent(event);
                }
            }
            
            // Small delay between removals
            await new Promise(resolve => setTimeout(resolve, 25));
        }
        
    } catch (error) {
        console.error('Error during auto-removal:', error);
    }
}

function initUpsell() {
    const upsellWidget = document.querySelector('.cart-upsell');
    const autoRemoveElement = document.querySelector('.cart-upsell-auto-remove');
    
    // Handle auto-removal of orphaned upsell items
    if (autoRemoveElement) {
        autoRemoveUpsellItems();
        return; // Don't initialize the widget if we're removing items
    }
    
    if (upsellWidget) {
        if (upsellInstance) {
            // Clean up old instance
            upsellInstance.removeEventListeners();
            upsellInstance.reinit();
        } else {
            upsellInstance = new BelnuUpsell(upsellWidget);
        }
    } else {
        // Widget not found, clean up instance
        if (upsellInstance) {
            upsellInstance.removeEventListeners();
            upsellInstance = null;
        }
    }
}

// Initialize on DOM load
window.addEventListener('DOMContentLoaded', initUpsell);

// Reinitialize after cart updates with debouncing to prevent multiple rapid calls
let upsellReinitTimeout;
document.addEventListener('belnuCartUpdated', () => {
    // Debounce to prevent multiple rapid reinitializations
    clearTimeout(upsellReinitTimeout);
    upsellReinitTimeout = requestAnimationFrame(() => {
        initUpsell();
    });
});
